/* KW 3.0 — reviews.

   Judge.me renders the reviews server-side and leaves three jobs to its own
   script, which this theme does not load (see kw-reviews.css for why). Those
   three jobs are all that stand between the SSR markup and a finished block:

     photos      arrive as data-src, so the browser never fetches them
     timestamps  arrive empty, with the real date on the datetime attribute
     the bars    arrive as the text "5 stars: 73 (86%)"

   Everything else is already in the HTML. If this file fails to run the block
   still reads correctly — dates and photos are simply absent — which is the
   whole advantage of styling server-rendered markup rather than waiting on a
   widget to build itself.
*/

(function () {
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];

  /* ── Which review photos are the customer's ──────────────────
     Twenty-four of the twenty-six photos on the wash system are the same K+W
     marketing shot, attached to reviews when they were imported. A product
     photo repeated under twenty different names is not social proof — the two
     that are worth showing are the ones where somebody photographed their own
     car.

     The marker is structural, not a brand name: Judge.me writes an imported
     attachment as <id>__0__<token>__<AssetName>__original, where a genuine
     upload is <id>__<timestamp>-<filename>__original. Matching on "__0__"
     rather than on "KW_" means this keeps working when the marketing asset is
     renamed, and does not silently hide a customer who happens to name their
     photo after the brand. Checked against all 26: the two rules agreed on
     every one.

     Skipped photos are never given a src, so this also saves the page two
     dozen image requests. */
  var IMPORTED = /__0__/;

  function fileOf(url) {
    var clean = String(url).split('?')[0];
    return clean.substring(clean.lastIndexOf('/') + 1);
  }

  /* The frame is visible from the start and comes out only if the file fails.
     Revealing on load instead deadlocks: a lazy image inside a hidden parent
     is never in the viewport, so it is never fetched, so load never fires. */
  function paintPhotos(root) {
    root.querySelectorAll('.jdgm-rev__pic-img[data-src]').forEach(function (img) {
      var src = img.getAttribute('data-src');
      var link = img.closest('.jdgm-rev__pic-link');
      if (!src) return;

      if (IMPORTED.test(fileOf(src))) {
        if (link) link.classList.add('kw-rv--dead');
        img.removeAttribute('data-src');
        return;
      }

      img.loading = 'lazy';
      img.decoding = 'async';
      img.addEventListener('error', function () {
        if (link) link.classList.add('kw-rv--dead');
        tidyStrip(root);
      });
      img.src = src;
      img.removeAttribute('data-src');
    });
    tidyStrip(root);
  }

  /* A strip whose every photo has been dropped still holds its top margin, so
     the card gains a band of empty space under the copy. :empty cannot see
     this — the children are present, just hidden. */
  function tidyStrip(root) {
    root.querySelectorAll('.jdgm-rev__pics').forEach(function (strip) {
      var links = strip.querySelectorAll('.jdgm-rev__pic-link');
      var dead = strip.querySelectorAll('.jdgm-rev__pic-link.kw-rv--dead');
      strip.classList.toggle('kw-rv--dead', links.length > 0 && links.length === dead.length);
    });
  }

  function paintDates(root) {
    root.querySelectorAll('time.jdgm-rev__timestamp').forEach(function (t) {
      if (t.textContent.trim()) return;
      var iso = t.getAttribute('datetime');
      if (!iso) return;
      var d = new Date(iso);
      if (isNaN(d.getTime())) return;
      t.textContent = d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
      t.classList.remove('jdgm-spinner');
    });
  }

  /* "5 stars: 73 (86%)" becomes a labelled row with a bar. The percentage in
     the string is Judge.me's own rounding and is used as given rather than
     recomputed — two sources for one number is how they end up disagreeing. */
  var DIST = /^\s*(\d)\s*stars?\s*:\s*([\d,]+)\s*\((\d+)%\)/i;

  function paintDistribution(root) {
    root.querySelectorAll('.jdgm-ssr-rating-distribution li').forEach(function (li) {
      if (li.querySelector('.kw-rv__bar')) return;
      var m = li.textContent.match(DIST);
      if (!m) return;

      var stars = m[1], count = m[2], pct = m[3];
      li.textContent = '';

      var label = document.createElement('span');
      label.textContent = stars + ' star' + (stars === '1' ? '' : 's');

      var bar = document.createElement('span');
      bar.className = 'kw-rv__bar';
      var fill = document.createElement('i');
      fill.style.setProperty('--kw-pct', pct + '%');
      bar.appendChild(fill);

      var n = document.createElement('span');
      n.textContent = count + ' (' + pct + '%)';
      n.style.textAlign = 'right';

      li.appendChild(label);
      li.appendChild(bar);
      li.appendChild(n);
    });
  }

  function addReveal(root) {
    var list = root.querySelector('.jdgm-ssr-reviews__list');
    if (!list || list.dataset.kwReveal === '1') return;

    var total = list.querySelectorAll('.jdgm-rev').length;
    /* The CSS shows six on a desktop and four on a phone. Six is the lower
       bar to clear, so below seven there is nothing to reveal on either. */
    if (total < 7) return;
    list.dataset.kwReveal = '1';

    /* Judge.me's server-rendered payload carries the most recent reviews,
       not every one — 25 of 86 on the wash system. The button says how many
       are on this page and the line under it says how many exist, with the
       route to the rest, so the two numbers on the page stop disagreeing. */
    var all = parseInt(root.dataset.count, 10) || 0;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kw-rv__more';
    btn.textContent = 'Read all ' + total + ' reviews on this page';
    btn.addEventListener('click', function () {
      list.classList.add('kw-rv--all');
      btn.hidden = true;
    });
    list.parentNode.insertBefore(btn, list.nextSibling);

    if (all > total) {
      var more = document.createElement('p');
      more.className = 'kw-rv__all';
      more.innerHTML = 'The ' + total + ' most recent of ' + all + '. ' +
        '<a href="/pages/reviews">See every product\'s reviews →</a>';
      btn.parentNode.insertBefore(more, btn.nextSibling);
    }
  }

  function init() {
    document.querySelectorAll('.jdgm-widget').forEach(function (root) {
      if (root.dataset.kwReviewsReady === '1') return;
      root.dataset.kwReviewsReady = '1';
      paintPhotos(root);
      paintDates(root);
      paintDistribution(root);
      addReveal(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();